import { render } from "./TenWeekPicks.vue?vue&type=template&id=791a2f10"
import script from "./TenWeekPicks.vue?vue&type=script&lang=ts"
export * from "./TenWeekPicks.vue?vue&type=script&lang=ts"
script.render = render

export default script